import React, { Component } from "react";
import { Link } from "react-router-dom";
import TopBar from "../__shared__/TopBar";
import "./styles.css";
import { connect } from "react-redux";
import {
    EMPTY_STRING,
    imageSize,
    clientErrorMessages,
    stepPath,
    BROADCAST_CHANNEL_NAME,
    BROADCAST_CHANNEL_LOGOUT_MSG,
} from "../../constants";
import { withRouter } from "react-router";
import blankUser from "../../assets/blank_user.svg";
import { handleLogout, setUserData } from "../Login/actions";
import PropTypes from "prop-types";
import { PROFILE_MENU_ITEMS } from "./constants";
import ReportBugs from "./ReportBugs";
import AboutThisSoftware from "./AboutThisSoftware";
import Security from "./Security";
import PreviousStepButton from "../__shared__/PreviousStepButton";
import ProfileInfoPage from "./ProfileInfoPage";
import { withAuth0 } from "@auth0/auth0-react";
import { If, Then } from "react-if";
import UnfoldLogo from "../../ui/logos/UnfoldLogo";

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedMenuItem: PROFILE_MENU_ITEMS.ACCOUNT_INFO,
        };

        this.fileInputRef = React.createRef();
        this.openFileDialog = this.openFileDialog.bind(this);
        this.onChange = this.onChange.bind(this);
        this.setSelectedMenuItem = this.setSelectedMenuItem.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.getMenuItemClassName = this.getMenuItemClassName.bind(this);
    }

    setSelectedMenuItem(itemName) {
        this.setState({
            selectedMenuItem: itemName,
        });
    }

    componentDidMount() {
        const { selectedMenuItem } = this.props.location.state || {
            selectedMenuItem: PROFILE_MENU_ITEMS.ACCOUNT_INFO,
        };
        this.setState({ selectedMenuItem });
    }

    openFileDialog() {
        this.fileInputRef.current.click();
    }

    onChange(e) {
        const files = e.target.files;

        if (files.length > 0) {
            let imageFile = files[0];
            if (imageFile.size < imageSize.PROFILE_PIC_MIN) {
                alert(clientErrorMessages.PROFILE_PICTURE_TOO_SMALL);
                return;
            }

            if (imageFile.size > imageSize.PROFILE_PIC_MAX) {
                alert(clientErrorMessages.PROFILE_PICTURE_TOO_LARGE);
                return;
            }
        }
    }

    closePopup() {
        this.fileInputRef.current.value = EMPTY_STRING;
        this.setState({ popup: EMPTY_STRING });
    }

    getMenuItemDisplay(selectedItem) {
        const profileInfoPageComponent = (
            <ProfileInfoPage
                userData={this.props.userData}
                authToken={this.props.authToken}
            />
        );

        switch (selectedItem) {
            case PROFILE_MENU_ITEMS.ACCOUNT_INFO:
                return profileInfoPageComponent;

            case PROFILE_MENU_ITEMS.REPORT_BUGS:
                return (
                    <ReportBugs
                        uuid={this.props.userData.uuid}
                        authToken={this.props.authToken}
                        email={this.props.userData.email}
                    />
                );

            case PROFILE_MENU_ITEMS.ABOUT_THIS:
                return <AboutThisSoftware />;

            case PROFILE_MENU_ITEMS.SECURITY:
                return (
                    <Security
                        userData={this.props.userData}
                        authToken={this.props.authToken}
                        handleLogout={this.handleLogout}
                    />
                );

            default:
                return profileInfoPageComponent;
        }
    }

    getMenuItemClassName = (menuItem) =>
        "profile-page-left-menu-item" +
        (this.state.selectedMenuItem === menuItem ? " active" : "");

    handleLogout() {
        this.props.handleLogout();
        const logoutChannel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
        logoutChannel.postMessage(BROADCAST_CHANNEL_LOGOUT_MSG);
        this.props.auth0.logout({
            logoutParams: { returnTo: window.location.origin + stepPath.LOGIN },
        });
    }

    render() {
        const userData = this.props.userData;
        let profilePictureUrl = userData.profilePictureUrl
            ? userData.profilePictureUrl
            : blankUser;

        const isSSOUser = this.props.flags.isSSOUser;

        return (
            <div id="profile-grid-layout">
                <TopBar id="profile-topbar">
                    <PreviousStepButton
                        to={stepPath.HOME}
                        style={{ margin: 30 }}
                    />
                    <Link to={stepPath.HOME}>
                        <UnfoldLogo />
                    </Link>
                </TopBar>
                <div
                    id="profile-menu-container"
                    className="profile-child-container rounded-xl text-lg"
                >
                    <div>
                        <div
                            className={
                                this.getMenuItemClassName(
                                    PROFILE_MENU_ITEMS.ACCOUNT_INFO
                                ) + " rounded-t-xl hover:rounded-t-xl"
                            }
                            onClick={() => {
                                this.setSelectedMenuItem(
                                    PROFILE_MENU_ITEMS.ACCOUNT_INFO
                                );
                            }}
                        >
                            {PROFILE_MENU_ITEMS.ACCOUNT_INFO}
                        </div>
                        <div
                            id="left-menu-item-about"
                            className={this.getMenuItemClassName(
                                PROFILE_MENU_ITEMS.ABOUT_THIS
                            )}
                            onClick={() => {
                                this.setSelectedMenuItem(
                                    PROFILE_MENU_ITEMS.ABOUT_THIS
                                );
                            }}
                        >
                            {PROFILE_MENU_ITEMS.ABOUT_THIS}
                        </div>
                        <If condition={!isSSOUser}>
                            <Then>
                                <div
                                    className={this.getMenuItemClassName(
                                        PROFILE_MENU_ITEMS.SECURITY
                                    )}
                                    id="left-menu-item-security"
                                    onClick={() => {
                                        this.setSelectedMenuItem(
                                            PROFILE_MENU_ITEMS.SECURITY
                                        );
                                    }}
                                >
                                    {PROFILE_MENU_ITEMS.SECURITY}
                                </div>
                            </Then>
                        </If>
                        <div
                            className={this.getMenuItemClassName(
                                PROFILE_MENU_ITEMS.REPORT_BUGS
                            )}
                            onClick={() => {
                                this.setSelectedMenuItem(
                                    PROFILE_MENU_ITEMS.REPORT_BUGS
                                );
                            }}
                        >
                            {PROFILE_MENU_ITEMS.REPORT_BUGS}
                        </div>
                    </div>
                    <button
                        id="profile-page-left-menu-logout-button"
                        className="border-primary-500 text-primary-500 hover:bg-primary-500 rounded-md border-2 hover:text-white"
                        onClick={this.handleLogout}
                    >
                        Log Out
                    </button>
                </div>
                <div
                    className="profile-child-container rounded-xl"
                    id="profile-content-container"
                >
                    <div id="profile-content-header" className="text-[28px]">
                        {this.state.selectedMenuItem}
                    </div>
                    <div id="profile-content-container-content">
                        {userData
                            ? this.getMenuItemDisplay(
                                  this.state.selectedMenuItem,
                                  userData,
                                  profilePictureUrl
                              )
                            : null}
                    </div>
                </div>
            </div>
        );
    }
}

Profile.propTypes = {
    authToken: PropTypes.string,
    history: PropTypes.object,
    handleLogout: PropTypes.func,
    onClick: PropTypes.func,
    children: PropTypes.any,
    id: PropTypes.string,
    setUserData: PropTypes.func,
    userData: PropTypes.object,
    location: PropTypes.shape({
        state: PropTypes.object,
    }),
    auth0: PropTypes.object,
    flags: PropTypes.object,
};

Profile.defaultProps = {
    authToken: EMPTY_STRING,
    userData: {},
};

const mapStateToProps = function (state) {
    return {
        userData: state.LoginReducer.userData,
        authToken: state.LoginReducer.authToken,
        flags: state.LoginReducer.flags,
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        setUserData: (userData) => dispatch(setUserData(userData)),
        handleLogout: () => dispatch(handleLogout()),
    };
};

export default withAuth0(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile))
);
